import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import { API_BASE_URL } from '@/config';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    cartProducts: [],

    userAccessKey: null,

    cartProductsData: [],

    loadCartPage: false,
    loadIndicator: false,

    orderInfo: null,
  },

  mutations: {
    updateOrderInfo(state, orderInfo) {
      state.orderInfo = orderInfo;
    },

    resetCart(state) {
      state.cartProducts = [];
      state.cartProductsData = [];
    },
    updateCartProductAmount(state, { productId, amount }) {
      // eslint-disable-next-line
      const item = state.cartProducts.find(item => item.productId === productId);
      if (item) {
        item.amount = amount;
      }
    },
    deleteCartProduct(state, productId) {
      // eslint-disable-next-line
      state.cartProducts = state.cartProducts.filter(item => {
        return item.productId !== productId;
      });
    },
    updateUserAccessKey(state, accessKey) {
      state.userAccessKey = accessKey;
    },
    updateCartProductsData(state, items) {
      state.cartProductsData = items;
    },
    /* eslint-disable */
    syncCartProducts(state) {
      state.cartProducts = state.cartProductsData.map(item => {
        return {
          productId: item.product.id,
          amount: item.quantity,
        }
      });
    }
  },

  /* eslint-disable */
  getters: {
    cartDetailProducts(state) {
      return state.cartProducts.map(item => {
        const product = state.cartProductsData.find(p => p.product.id === item.productId).product;
        return {
          ...item,
          product: {
            ...product,
            image: product.image.file.url,
          }
        }
      });
    },
    cartTotalPrice(state, getters) {
      return getters.cartDetailProducts.reduce((acc, item) => (item.product.price * item.amount) + acc, 0);
    },
    cartTotalName(state, getters) {
      const res = String(getters.cartDetailProducts.reduce((acc, item) => (item.amount) + acc, 0));

      function normalizeCount(num) {
        if (num != 11 && num != 111 && num != 211 && num != 311 && num != 411 && num != 511 && num[num.length - 1] == 1) {
          return num + ' товар';
        } else if ((num[num.length - 1] == 2 || num[num.length - 1] == 3 || num[num.length - 1] == 4) && (num != 12 && num != 13 && num != 14)) {
          return num + ' товара';
        } else {
          return num + ' товаров';
        }
      }
      return normalizeCount(res);
    }
  },
  actions: {
    loadOrderInfo(context, orderId) {
      return axios
      .get(API_BASE_URL + '/api/orders/' + orderId, {
        params: {
          userAccessKey: context.state.userAccessKey
        }
      })
      .then(response => {
        context.commit('updateOrderInfo', response.data);
      })
    },
    loadCart(context) {
      context.state.loadIndicator = true;
      context.state.loadCartPage = true;
      clearTimeout(this.loadCartPageTimer);
      this.loadCartPageTimer = setTimeout(() => {
        return axios.get(API_BASE_URL + '/api/baskets', {
          params: {
            userAccessKey: context.state.userAccessKey
          }
        })
          .then(response => {
            if (!context.state.userAccessKey) {
              localStorage.setItem('userAccessKey', response.data.user.accessKey)
              context.commit('updateUserAccessKey', response.data.user.accessKey)
            }

            context.commit('updateCartProductsData', response.data.items);
            context.commit('syncCartProducts');
          })
          .then(() => context.state.loadCartPage = false)
          .then(() => context.state.loadIndicator = false)
      }, 3000)
    },
    addProductToCart(context, { productId, amount }) {
      return (new Promise(resolve => setTimeout(resolve, 2000)))
        .then(() => {
          return axios
            .post(API_BASE_URL + '/api/baskets/products', {
              productId: productId,
              quantity: amount
            }, {
              params: {
                userAccessKey: context.state.userAccessKey
              }
            })
            .then(response => {
              context.commit('updateCartProductsData', response.data.items);
              context.commit('syncCartProducts');
            })
        })
    },
    updateCartProductAmount(context, { productId, amount }) {
      context.commit('updateCartProductAmount', { productId, amount });

      if (amount < 1) {
        return;
      }

      return axios
        .put(API_BASE_URL + '/api/baskets/products', {
          productId: productId,
          quantity: amount
        }, {
          params: {
            userAccessKey: context.state.userAccessKey
          }
        })
        .then(response => {
          context.commit('updateCartProductsData', response.data.items);
        })
        .catch(() => {
          context.commit('syncCartProducts');
        })
    },
    deleteProductCart(context, { productId }) {
      context.commit('deleteCartProduct', productId);
      return axios
        .delete(API_BASE_URL + '/api/baskets/products', {
          params: {
            userAccessKey: context.state.userAccessKey
          },
          data: {
            productId: productId,
          }
        })
        .then(response => {
          context.commit('updateCartProductsData', response.data.items);
        })
        .catch(() => {
          context.commit('syncCartProducts');
        })
    }
  }
});
